// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3qRG5","alertIcon":"ConfirmModal_alertIcon__3GmBL"};